$(() => {

    const afterPlayShown = new Event('afterShown');


    setupCheckAllCheckbox();
    setupCheckboxToggle();
    setupBlurBoxCheck();
    searchInSelect();

    $('form:not(.no-focus) input:not(.no-focus):first').focus();

});

let setupCheckAllCheckbox = () => 
{
    $('input.checkAll').on('change', (event) => {

        var checkAll = $(event.target);

        ($('input[name=' + checkAll.attr('data-checkAll') + ']')).prop('checked', checkAll.prop('checked'));
        ($('input[name="' + checkAll.attr('data-checkAll') + '[]"]')).prop('checked', checkAll.prop('checked'));


    });
}



const formatCurrency = (amount, currency) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency;
}       



const smoothScrollToTarget = (target, speed = 800) => {
    
    if(target === "") { return; }

    const page = $('html, body');

    page.animate({scrollTop: $(target).offset().top - 80}, speed, () => {

    });

    page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", () => {
        page.stop();
    });

}


//#region /****** FORMS ******/
const setupTextInputEnterSubmit = (input, submit) => {
    
    input.on('keydown', (event) => {
        const keycode = event.keyCode || event.which;
        if(keycode == '13') { submit.click(); }
    });

}
//#endregion


//#region /****** GENERAL MESSAGES *******/
const showConnectionErrorMessage = () => {
    alert(localizedTexts.dev.connectionError);
    return;
}
//#endregion
//Primarily for datatable fixed header
function getNavbarHeight() {

    let height = $('.navbar').height();
	
    if($('.additionalSubbar').length > 0) { height += $('.additionalSubbar').height(); }

    if($('.division-info').length > 0) { height += $('.division-info').height(); }

    return height - 2;
}


function setupCheckboxToggle() {

    $('.checkbox-toggle').on('change', function() {

        const targetSelector = $(this).attr('data-target');
        const targetElement = $(targetSelector);


        const isChecked = $(this).prop('checked');
        
        if(isChecked) targetElement.show();
        else targetElement.hide();

    });

}


function setupBlurBoxCheck() {

    const blurBoxes = $('.blur-box');
    if(blurBoxes.length === 0) { return; }


    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
            mutationRecord.target.remove()
        });    
    });

    blurBoxes.each(function() {
        $(this).css('filter', 'blur(10px)');
        $(this).css('user-select', 'none');
        observer.observe($(this)[0], { attributes : true, attributeFilter : ['class', 'style'] });
    });

}


function searchInSelect() {

    if($('.searchInput').length <= 0) { return; }

    const searchInput = $('.searchInput');
    const selectInput = $('#' + searchInput.attr('data-target'));

    let records = [];
    selectInput.find('option').each(function(index, option) {
        records[$(option).val()] = $(option).text();
    });

    searchInput.on('keyup', function() {

        const searchValue = $(this).val().toLowerCase();
    
        if(searchValue === '') {
            $('option', selectInput).prop('selected', false);
        }


        let found = false;
        records.forEach(
            (value, recordIndex) => {
                
                if(!found) 
                {
                    if(value.toLowerCase().indexOf(searchValue) !== -1) 
                    {
                        selectInput.find('option[value="' + recordIndex + '"]').prop('selected', true);
                        found = true;
                    }
                }
            }
        );


        if(!found) { selectInput.find('option').prop('selected', false); }
    })

}


function secondsToTime(s) {
    var h = Math.floor(s / 3600); //Get whole hours
    s -= h * 3600;
    var m = Math.floor(s / 60); //Get remaining minutes
    s -= m * 60;
    return h + ":" + (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s); //zero padding on minutes and seconds
  }